import { render, staticRenderFns } from "./DialogStudy.vue?vue&type=template&id=238e9516&"
import script from "./DialogStudy.vue?vue&type=script&lang=js&"
export * from "./DialogStudy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports